import {
  Box,
  Grid,
  Snackbar,
  Button,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core'
import React, { useState } from 'react'
import Card from '../../../../components/common/Card'
import { useStyles } from './LeftCheckout.style'
import { useEffect } from 'react'
// import { getAddressUser } from "../../../../store/actions/GetAddressActions";
// import { GetAddressResponse } from "../../../../store/Selectors/getaddress";
// import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom'
// import { GetShippingDataResponse } from "../../../../store/Selectors/getShipping";
// import { GetPaymentDataResponse } from "../../../../store/Selectors/getpaymentdata";
// import { getPaymentProductUser } from "../../../../store/actions/getPaymentActions";
import RightCheckout from '../right/RightCheckout'
// import { addOrderProduct } from "../../../../store/actions/AddOrderActions";
import Amount from '../../../../components/common/Amount'
// import { AddOrderResponse } from "../../../../store/Selectors/AddOrder";
import MuiAlert from '@material-ui/lab/Alert'
import i18n from '../../../language/localization'
import { t } from 'i18next'
import CloseIcon from '@material-ui/icons/Close'
// import {
//   getCityDataUser,
//   getDistrictDataUser,
//   getProvinceDataUser,
// } from "../../../../store/actions/getProvinceCityDistrict";
// import {
//   GetCityResponse,
//   GetDistrictResponse,
//   GetProvinceResponse,
// } from "../../../../store/Selectors/getCityDistrictData";
// import { addAddressUser } from "../../../../store/actions/userActions";
import { get as getCart, updateCheckedAll } from '../../../../api/cart'
import { getDetail as getAddressDetail } from '../../../../api/address'
import { update as updateAddressData } from '../../../../api/address'
import {
  // getProvince as getProvinceData,
  getCity as getCityData,
  getDistrict as getDistrictData
} from '../../../../api/region'
import { createCheckout, create as submitCheckout } from '../../../../api/checkout'
import { useSelector } from 'react-redux'
import { isDiscountValid } from '../../../../utils/pricing'
import { formatDate } from 'utils/helper'

const userid = JSON.parse(localStorage.getItem('userid'))

const LeftCheckout = props => {
  const { checkoutCartItem, isCheckout } = useSelector(state => state.cart)
  const { webThemeColor } = props

  const orderDetailCart = checkoutCartItem
    .filter(item => Boolean(item.order_cart_item.checked_out))
    .map(item => item.order_cart_item)
  // const orderDetailCart = checkoutCartItem;
  const orderDetailComplete = checkoutCartItem.filter(item => item.order_cart_item.checked_out)

  // const orderDetailCart = JSON.parse(localStorage.getItem("oderDetail"));
  // console.log("orderDetailCart", orderDetailCart);
  let history = useHistory()
  const classes = useStyles()
  // const dispatch = useDispatch();
  // const [checked, setChecked] = useState(false)
  // const [radioJT, setRadioJT] = useState('')

  const [bankId, setBankId] = useState()
  // const [isCOD, setISCod] = useState(false)
  // const [isBankAuto, setISBankAuto] = useState(false)
  const [singleShipping, setSingleShipping] = useState({})
  const [shipingCost, setShipingCost] = useState(0)
  const [isSnackbar, setSnackbar] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [uniqueCode, setUniquecode] = React.useState()
  const [uniqueCodeStatus, setuniqueCodeStatus] = React.useState()
  // const [shippingId, setShippingId] = React.useState()
  // const [showSelfPick, setShowSelfPick] = React.useState(false)
  // const [showCourierRajaOngkir, setShowCourierRajaOngkir] = React.useState(false)
  // const [showCourierVendor, setShowCourierVendor] = React.useState(false)

  const [addressData, setAddressData] = React.useState([])
  const [provinceData, setProvinceData] = React.useState([])
  const [cityData, setCityData] = React.useState([])
  const [districtData, setdistrictData] = React.useState([])
  const [ppnTaxShippingAmount, setPpnTaxShippingAmount] = useState(0)
  const [fixTaxAmount, setFixTaxAmount] = useState(0)
  const [getCartData, setGetCartData] = useState([])

  // pajak pengiriman calculate -> if active
  const calculatePPNBaseONWeightGram = data => {
    const totalWeighGram = orderDetailCart.reduce(
      (acc, val) => acc + val.weight * val.checked_out_quantity,
      0
    )
    const parameterInit = data.shipping_tax_parameter_init
    const parameterMultiple = data.shipping_tax_parameter_multiple
    const parameterPriceInit = data.shipping_tax_by_weight
    const totalGrams = totalWeighGram
    let value = 0

    if (totalGrams <= parameterInit) {
      value = parameterPriceInit
    } else {
      let i = 1
      let end = true
      do {
        const parameter = parameterInit
        const nextParameter = parameterInit + parameterMultiple * i

        if (totalGrams > parameter && totalGrams <= nextParameter) {
          value = parameterPriceInit * (i + 1)
          end = false
          break
        } else {
          value = 0
        }
        i++
      } while (end)
    }

    setPpnTaxShippingAmount(value)
  }

  // pajak tetap calculate -> if active
  const calculateFixTaxAmount = data => {
    setFixTaxAmount(data.reduce((acc, val) => acc + val.fix_tax * val.checked_out_quantity, 0))
  }

  const [checkOut2, setcheckOut2] = useState()

  const [checkOut, setcheckOut] = useState(isCheckout ? '' : 'Cash')
  const [radioPO, setRadioPO] = useState(checkOut == 'Cash' ? 'Cash' : '')
  const [isBank, setBank] = useState(false)
  const [loadingBtn, setLoadingBtn] = useState(false)

  const [addressPrimary, setaddressPrimary] = useState([])
  const [openPopUpAddressList, setOpenPopUpAddressList] = useState(false)
  const handleClosePopUpAddressList = async () => {
    setOpenPopUpAddressList(false)
  }
  const handleClickOpenPopUpAddressList = async () => {
    setOpenPopUpAddressList(true)
  }
  const [addressChecked, setAddressChecked] = useState({})
  const handleChangeRadioAddressList = e => {
    setAddressChecked(JSON.parse(e.target.value))
  }

  const getData = async () => {
    const userID = JSON.parse(localStorage.getItem('userid'))
    let response

    try {
      response = await getAddressDetail(`{"customer_id":${userID}}`)
      setAddressData(response)

      if (response) {
        let primaryAddress = [...response].filter(
          dt => dt.customer_address_mappings?.[0]?.customer_address_mapping?.is_primary
        )

        if (!primaryAddress.length) {
          primaryAddress = response
        }

        setaddressPrimary(primaryAddress)
        // await shipping(primaryAddress)
      }
    } catch (error) {
      console.log('Error fetching data:', error)
    }
  }

  const handleClickChangeAddress = async () => {
    setaddressPrimary([addressChecked])
    setOpenPopUpAddressList(false)
  }
  const [openPopUpAddressUpdate, setOpenPopUpAddressUpdate] = useState(false)
  const handleClosePopUpdateAddress = async () => {
    setOpenPopUpAddressUpdate(false)
  }

  const handleClickChangeAddressUpdate = async () => {
    setLoading(true)
    const data = {
      address_id: formdata.id,
      customer_id: parseInt(userid),
      name: formdata.name,
      phone: formdata.phone,
      address: formdata.address,
      province_id: parseInt(formdata.province_id),
      district_id: parseInt(formdata.district_id),
      subdistrict_id: parseInt(formdata.subdistrict_id),
      postal_code: formdata.postal_code,
      country_id: 62,
      village_id: 3201130010,
      latitude: -6.534398,
      longitude: 106.821891,
      note: '',
      label: '',
      is_primary: formdata.is_primary
    }

    const response = await updateAddressData(data)
    if (response.success) {
      await getData()
      setLoading(false)
      setOpenPopUpAddressUpdate(false)
      setOpenPopUpAddressList(true)
    }
  }

  const [formdata, setFormData] = useState(null)
  const onChangeNameForUpdateAddress = e => {
    setFormData({ ...formdata, name: e.target.value })
  }
  const onChangeAddressForUpdateAddress = e => {
    setFormData({ ...formdata, address: e.target.value })
  }
  const onChangePostCodeForUpdateAddress = e => {
    setFormData({ ...formdata, postal_code: e.target.value })
  }
  const onChangePhoneForUpdateAddress = e => {
    setFormData({ ...formdata, phone: e.target.value })
  }
  const getDistric = async e => {
    const selectedProvinceName = provinceData.find(dt => dt.id === e.target.value)?.name

    setFormData({ ...formdata, province_id: e.target.value })
    setFormData({ ...formdata, province_name: selectedProvinceName })
    try {
      const response = await getCityData(`{"province_id":${e.target.value}}`)

      setCityData(response)
    } catch (error) {
      console.log('Error fetching getCityData:', error)
    }
  }
  const getSubDistrict = async e => {
    const selectedCityName = cityData.find(dt => dt.id === e.target.value)?.name
    setFormData({ ...formdata, district_id: e.target.value })
    setFormData({ ...formdata, district_name: selectedCityName })
    try {
      const response = await getDistrictData(`{"district_id":${e.target.value}}`)

      setdistrictData(response)
    } catch (error) {
      console.log('Error fetching getDistrictData:', error)
    }
  }
  const subDistChange = e => {
    setFormData({ ...formdata, subdistrict_id: e.target.value })
  }

  // On Click Checkout Button !NOT CHECKOUT!
  const placeOrder = async ({ departmentId, costCenterId }) => {
    try {
      if (addressPrimary.length > 0) {
        const newCheckoutData = {
          customer_address_id: addressPrimary[0].customer_address.id,
          department_ids: departmentId ? [Number(departmentId)] : [],
          cost_center_ids: costCenterId ? [Number(costCenterId)] : [],
          order_cart_item_ids: checkoutCartItem.map(_checkout => _checkout.order_cart_item.id)
        }

        const resSubmitCheckout = await createCheckout(newCheckoutData)
        if (resSubmitCheckout.success) {
          localStorage.setItem('order_id', resSubmitCheckout.data.id)
          history.push('/success-order-pay')
        }
      } else {
        alert('Select Delivery Address')
      }
    } catch (error) {
      console.error('ERROR placeOrder')
    }
  }

  const ReturnTotal = () => {
    const total = orderDetailCart.reduce((acc, val) => acc + val.price * val.quantity, 0)
    const grand_total = shipingCost + total
    if (isCheckout) {
      if (isBank) {
        if (uniqueCodeStatus == 1) {
          return grand_total + parseInt(uniqueCode) + ppnTaxShippingAmount + fixTaxAmount
        } else {
          return grand_total + ppnTaxShippingAmount + fixTaxAmount
        }
      } else {
        return grand_total + ppnTaxShippingAmount + fixTaxAmount
      }
    } else {
      if (isBank) {
        if (uniqueCodeStatus == 1) {
          return grand_total + parseInt(uniqueCode)
        } else {
          return grand_total
        }
      } else {
        return grand_total
      }
    }
  }

  // On Click Pay On Spot Button
  const placeOrderPayonspot = async () => {
    setLoadingBtn(true)

    try {
      if (radioPO == 'Cash' || bankId) {
        const total = orderDetailCart.reduce(
          (acc, val) => acc + val.price * val.checked_out_quantity,
          0
        )
        const totalDiscount = orderDetailCart.reduce(
          (acc, val) => acc + val.discount * val.checked_out_quantity,
          0
        )
        let data = {}
        if (radioPO == 'Cash') {
          data = {
            payment_method: 'CASH',
            payment_method_id: null,
            order_placed_from: 'WEB',
            shipping_type: 'SELFPICKUP',
            shipping_tax: 0,
            grand_total: ReturnTotal(),
            total: total - totalDiscount,
            tax: 0,
            discount: totalDiscount,
            is_moota: false,
            shipping: {
              name: 'Ambil Sendiri',
              estimation: null,
              service: 'SELFPICKUP',
              price: 0,
              logo: null
            },
            is_pay_on_spot: true
          }
        } else if (radioPO == 'Bank (Konfirmasi Manual)') {
          data = {
            payment_method: 'BANK TRANSFER',
            payment_method_id: parseInt(bankId),
            order_placed_from: 'WEB',
            shipping_type: 'SELFPICKUP',
            shipping_tax: 0,
            grand_total: ReturnTotal(),
            total: total - totalDiscount,
            tax: 0,
            is_moota: false,
            discount: totalDiscount,
            shipping: {
              name: 'Ambil Sendiri',
              estimation: null,
              service: 'SELFPICKUP',
              price: 0,
              logo: null
            },
            is_pay_on_spot: true
          }
        } else if (radioPO == 'Bank (Konfirmasi Otomatis)') {
          data = {
            payment_method: 'BANK TRANSFER',
            payment_method_id: null,
            order_placed_from: 'WEB',
            shipping_type: 'SELFPICKUP',
            shipping_tax: 0,
            grand_total: ReturnTotal(),
            total: total - totalDiscount,
            tax: 0,
            is_moota: true,
            discount: totalDiscount,
            shipping: {
              name: 'Ambil Sendiri',
              estimation: null,
              service: 'SELFPICKUP',
              price: 0,
              logo: null
            },
            is_pay_on_spot: true
          }
        }

        const itemsCart = checkoutCartItem.map(item => ({
          id: item.order_cart_item.id,
          checked_out: item.order_cart_item.checked_out,
          checked_out_quantity: item.order_cart_item.checked_out_quantity
        }))

        const resUpdateCheckedAll = await updateCheckedAll(itemsCart)

        const resSubmit = await submitCheckout(data)

        if (resSubmit.success && resUpdateCheckedAll) {
          localStorage.setItem('order_id', resSubmit.data.id)
          history.push('/success-order-pay')
        }
      } else {
        alert('Select Payment')
        setLoadingBtn(false)
      }
    } catch (error) {
      console.error('ERROR placeOrderPayonspot')
    }
  }

  const GetCartData = async () => {
    const cartDataResult = await getCart(`{"get_all_data": true}`)
    if (cartDataResult.success) {
      setGetCartData(cartDataResult.data.order_cart_items)
    }
  }

  useEffect(() => {
    GetCartData()
    getData()

    const landingPageSettingLocalData = JSON.parse(localStorage.getItem('landing_page_setting'))
    if (landingPageSettingLocalData.is_shipping_tax_by_weight_checkout_active) {
      calculatePPNBaseONWeightGram(landingPageSettingLocalData)
    }

    if (landingPageSettingLocalData.is_fix_tax_product_checkout_active) {
      calculateFixTaxAmount(orderDetailCart)
    }

    i18n.changeLanguage(JSON.parse(localStorage.getItem('Language')))
    setcheckOut2(localStorage.getItem('checkoutPage'))
  }, [])

  // Get Cart Data End
  return (
    <div style={{ display: 'flex', columnGap: 20 }}>
      <div style={{ flex: 1 }}>
        {isCheckout && (
          <Card className={classes.cardStyle}>
            <Box>
              <header>
                <label>{t('delivery_address')} </label>
                {Boolean(addressPrimary.length) && (
                  <Button
                    onClick={handleClickOpenPopUpAddressList}
                    style={{
                      marginBottom: '0',
                      borderColor: webThemeColor,
                      color: webThemeColor,
                      width: '147px',
                      height: '35px'
                    }}
                    variant='outlined'
                    size='small'
                  >
                    {t('change_address')}
                  </Button>
                )}
              </header>
              <Box className={classes.address}>
                {/* {console.log("addressPrimary",addressPrimary)} */}

                {!addressPrimary.length && (
                  <Box
                    width='100%'
                    height={150}
                    display='flex'
                    flexDirection='column'
                    alignItems='center'
                    justifyContent='center'
                  >
                    <h5 style={{ fontSize: 16, fontWeight: 400 }}>
                      Please contact administrator for add address
                    </h5>
                  </Box>
                )}

                {addressPrimary.slice(0, 1).map((dt, index) => {
                  const isPrimary =
                    dt.customer_address_mappings?.[0]?.customer_address_mapping?.is_primary

                  return (
                    <div className='del-detail' key={index}>
                      <div className='del-to-name'>
                        {dt.customer_address.name}{' '}
                        {isPrimary ? (
                          <span className='default-lab' style={{ marginLeft: 4 }}>
                            Default
                          </span>
                        ) : null}
                      </div>
                      <div className='del-transaction-no'>{dt.customer_address.phone}</div>
                      <div className='del-address'>
                        {dt.customer_address.address}
                        <br />
                        {dt.sub_district.name}, {dt.district.name}, {dt.province.name}
                        {dt.sub_district.postal_code ? `- ${dt.sub_district.postal_code}` : ''}
                      </div>
                    </div>
                  )
                })}
              </Box>
            </Box>
          </Card>
        )}

        {/* Order Details */}
        <Card className={classes.cardStyle + '  '}>
          <Box className={classes.radio_style}>
            <header>
              <label>{t('order_detail')}</label>
            </header>
            {orderDetailComplete.map((cart, index) => {
              return (
                <Box className={classes.tableContent} key={index}>
                  <Grid container spacing={2}>
                    <Grid item md={2}>
                      <img
                        src={
                          cart.product.media && cart.product.media.length > 0
                            ? process.env.REACT_APP_FILE_BASE_URL + '/' + cart.product.media[0]
                            : '/assets/images/dummy.png'
                        }
                        style={{ position: 'relative', width: '100px', height: '100px' }}
                        alt=''
                      />
                    </Grid>
                    {isDiscountValid(
                      cart.product.discount,
                      cart.product.discount_start_date,
                      cart.product.discount_end_date
                    ) && (
                      <div
                        style={{
                          background: ' #D92D20',
                          color: '#fff',
                          fontSize: '12px',
                          width: '28px',
                          height: '19px',
                          position: 'absolute',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginTop: '11px',
                          marginLeft: '76px'
                        }}
                      >
                        {cart.product.discount}%
                      </div>
                    )}

                    <Box className={classes.description_style}>
                      <p style={{ fontSize: 15, marginBottom: 4 }}>{cart.product.sku}</p>
                      <h4 className='title_de'>{cart.order_cart_item.name}</h4>
                      <Box className={classes.priceContent_style}>
                        {!isDiscountValid(
                          cart.product.discount,
                          cart.product.discount_start_date,
                          cart.product.discount_end_date
                        ) ? (
                          <p className='values' style={{ fontSize: 16 }}>
                            Rp&nbsp;
                            <Amount
                              amount={cart.order_cart_item.price * cart.order_cart_item.quantity}
                            />
                          </p>
                        ) : (
                          <p className='values' style={{ fontSize: 16 }}>
                            Rp&nbsp;
                            <Amount
                              amount={
                                cart.order_cart_item.price * cart.order_cart_item.quantity -
                                cart.order_cart_item.discount
                              }
                            />
                          </p>
                        )}
                      </Box>
                      {cart.general_ledger_accounts && (
                        <p className='values' style={{ marginTop: 4, fontSize: 16 }}>
                          <span style={{ width: 150, display: 'inline-block' }}>G/L Account</span>
                          :&nbsp;&nbsp;&nbsp;
                          {cart.general_ledger_accounts
                            .map(gla => gla.general_ledger_account.name)
                            .join(', ')}
                        </p>
                      )}
                      {cart.order_cart_item.po_reason && (
                        <p style={{ marginTop: 4, marginBottom: 0, fontSize: 14, color: '#555' }}>
                          <span style={{ width: 150, display: 'inline-block' }}>PO Reason</span>
                          :&nbsp;&nbsp;&nbsp;&nbsp;
                          {cart.order_cart_item.po_reason}
                        </p>
                      )}
                      {cart.order_cart_item.note && (
                        <p style={{ marginTop: 4, marginBottom: 0, fontSize: 14, color: '#555' }}>
                          <span style={{ width: 150, display: 'inline-block' }}>Notes</span>
                          :&nbsp;&nbsp;&nbsp;&nbsp;
                          {cart.order_cart_item.note}
                        </p>
                      )}
                      {cart.order_cart_item.expect_date && (
                        <p style={{ marginTop: 4, marginBottom: 0, fontSize: 14, color: '#555' }}>
                          <span style={{ width: 150, display: 'inline-block' }}>
                            Expect Delivery Date
                          </span>
                          :&nbsp;&nbsp;&nbsp;&nbsp;
                          {formatDate(cart.order_cart_item.expect_date)}
                        </p>
                      )}
                    </Box>
                  </Grid>
                </Box>
              )
            })}
            {/* <SkeletonCircleText /> */}
          </Box>
        </Card>
      </div>

      <div style={{ width: '352px' }}>
        <RightCheckout
          PlaceOrderClick={placeOrder}
          PlaceOrderClickPayonspot={placeOrderPayonspot}
          singleShipping={singleShipping}
          shippingCost={shipingCost}
          loding={isLoading}
          checkOut={checkOut}
          // CODfees={getCartData}
          getCartData={getCartData}
          isBank={isBank}
          webThemeColor={webThemeColor}
          loadingBtn={loadingBtn}
          ppnTaxShippingAmount={ppnTaxShippingAmount}
          fixTaxAmount={fixTaxAmount}
          grandTotal={ReturnTotal()}
        />
      </div>

      <Snackbar
        open={isSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={() => setSnackbar(false)}
        autoHideDuration={2000}
      >
        <MuiAlert severity='success'>{t('oder_add_successfully')}</MuiAlert>
      </Snackbar>

      <Dialog
        open={openPopUpAddressList}
        onClose={handleClosePopUpAddressList}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        classes={{ paper: classes.paperDialogAddressList }}
      >
        <DialogTitle id='alert-dialog-title' style={{ height: '50px', padding: '5px 15px' }}>
          <Grid container direction='row' justify='space-between' alignItems='center'>
            <label style={{ fontSize: '20px' }}>{'Choose Shipping Address'}</label>
            <CloseIcon
              onClick={handleClosePopUpAddressList}
              style={{ fontSize: '30px', paddingBottom: '10px' }}
            />
          </Grid>
        </DialogTitle>
        <DialogContent>
          {addressData
            ? addressData
              ? addressData.map((dt, index) => {
                  const isPrimary =
                    dt.customer_address_mappings?.[0]?.customer_address_mapping?.is_primary

                  return (
                    <div
                      key={index}
                      style={{
                        borderBottom: '1px solid #EBEBEB',
                        paddingTop: '20px',
                        paddingBottom: '20px'
                      }}
                    >
                      <Grid container>
                        <Grid item md={11}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 10,
                              marginBottom: 4
                            }}
                          >
                            {dt.customer_address.name}
                            {isPrimary ? (
                              <Button
                                variant='outlined'
                                color='secondary'
                                size='small'
                                style={{
                                  color: '#DC6803',
                                  border: '1px #DC6803 solid',
                                  padding: '2px 10px',
                                  fontSize: 10,
                                  textTransform: 'cap'
                                }}
                              >
                                {t('default_unbold')}
                              </Button>
                            ) : null}
                          </div>
                          {dt.customer_address.phone}
                        </Grid>
                        <Grid item md={1}>
                          <div className={classes.radio_item}>
                            <input
                              type='radio'
                              id={dt.customer_address.id}
                              value={JSON.stringify(dt)}
                              onChange={handleChangeRadioAddressList}
                              name='radioAddressChoice'
                              style={{
                                accentColor: webThemeColor,
                                height: '20px',
                                width: '20px',
                                cursor: 'pointer'
                              }}
                              key={index}
                              defaultChecked={
                                addressPrimary &&
                                addressPrimary.length > 0 &&
                                addressPrimary[0].customer_address.id === dt.customer_address.id
                                  ? true
                                  : false
                              }
                            />
                          </div>
                        </Grid>
                        {/* <Grid item md={3}>
                          <div
                            style={{
                              display: 'flex',
                              gap: '5px',
                              color: webThemeColor,
                              border: 'none',
                              alignItems: 'right',
                              justifyContent: 'right'
                            }}
                          >
                            <Button
                              style={{
                                background: 'transparent',
                                color: webThemeColor
                              }}
                              onClick={() => UpdateAddressOpenPopUp(dt.customer_address)}
                              size='small'
                            >
                              {t('edit')}
                            </Button>
                          </div>
                        </Grid> */}
                      </Grid>
                      <Grid container>
                        <Grid item md={11}>
                          {dt.customer_address.address}
                        </Grid>
                        <Grid item md={11}>
                          {dt.sub_district.name}, {dt.district.name}, {dt.province.name}
                          {dt.sub_district.postal_code ? `- ${dt.sub_district.postal_code}` : ''}
                        </Grid>
                      </Grid>
                    </div>
                  )
                })
              : null
            : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopUpAddressList} style={{ color: webThemeColor }}>
            {t('cancel1')}
          </Button>
          <Button
            variant='contained'
            onClick={handleClickChangeAddress}
            style={{ backgroundColor: webThemeColor, color: 'white' }}
          >
            {t('save')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPopUpAddressUpdate}
        onClose={handleClosePopUpdateAddress}
        aria-labelledby='alert-dialog-title-update-address'
        aria-describedby='alert-dialog-description-update-address'
        classes={{ paper: classes.paperDialogAddressUpdate }}
      >
        <DialogTitle id='alert-dialog-title' style={{ height: '50px', padding: '5px 15px' }}>
          <Grid container direction='row' justify='space-between' alignItems='center'>
            <label style={{ fontSize: '20px' }}>{'Ubah Alamat'}</label>
            <CloseIcon
              onClick={handleClosePopUpdateAddress}
              style={{ fontSize: '30px', paddingBottom: '10px' }}
            />
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container style={{ paddingTop: '15px' }}>
            <Grid item md={12}>
              <TextField
                type='text'
                label={t('name')}
                className={classes.borderColorTextfield}
                variant='outlined'
                size='small'
                style={{ width: '100%' }}
                defaultValue={formdata ? formdata.name : null}
                onChange={onChangeNameForUpdateAddress}
              />
            </Grid>
          </Grid>

          <Grid container style={{ paddingTop: '15px' }}>
            <Grid item md={12}>
              <TextField
                type='text'
                label={t('phone_number')}
                className={classes.borderColorTextfield}
                variant='outlined'
                size='small'
                style={{ width: '100%' }}
                defaultValue={formdata ? formdata.phone : null}
                onChange={onChangePhoneForUpdateAddress}
              />
            </Grid>
          </Grid>

          <Grid container style={{ paddingTop: '15px' }}>
            <Grid item md={12}>
              <FormControl variant='outlined' fullWidth>
                <InputLabel id='demo-simple-select-label-province'>{t('province')}</InputLabel>
                <Select
                  labelId='demo-simple-select-label-province'
                  id='demo-simple-select-province'
                  label={t('province')}
                  onChange={getDistric}
                  defaultValue={formdata ? formdata.province_id : null}
                >
                  {provinceData.length > 0
                    ? provinceData.map((dt, index) => {
                        return (
                          <MenuItem value={dt.id} key={index}>
                            {dt.name}
                          </MenuItem>
                        )
                      })
                    : null}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container style={{ paddingTop: '15px' }}>
            <Grid item md={12}>
              <FormControl variant='outlined' fullWidth>
                <InputLabel id='demo-simple-select-label-district-city'>
                  {t('district/city')}
                </InputLabel>
                <Select
                  labelId='demo-simple-select-label-district-city'
                  id='demo-simple-select-district-city'
                  label={t('district/city')}
                  onChange={getSubDistrict}
                  defaultValue={formdata ? formdata.district_id : null}
                >
                  {cityData.length > 0
                    ? cityData.map((ct, index) => {
                        return (
                          <MenuItem value={ct.id} key={index}>
                            {ct.name}
                          </MenuItem>
                        )
                      })
                    : null}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container style={{ paddingTop: '15px' }}>
            <Grid item md={12}>
              <FormControl variant='outlined' fullWidth>
                <InputLabel id='demo-simple-select-label-subdistricts'>
                  {t('subdistricts')}
                </InputLabel>
                <Select
                  labelId='demo-simple-select-label-subdistricts'
                  id='demo-simple-select-subdistricts'
                  label={t('subdistricts')}
                  onChange={subDistChange}
                  defaultValue={formdata ? formdata.subdistrict_id : null}
                >
                  {districtData.length > 0
                    ? districtData.map((sd, index) => {
                        return (
                          <MenuItem value={sd.id} key={index}>
                            {sd.name}
                          </MenuItem>
                        )
                      })
                    : null}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container style={{ paddingTop: '15px' }}>
            <Grid item md={12}>
              <TextField
                type='text'
                label={t('postcode')}
                className={classes.borderColorTextfield}
                variant='outlined'
                size='small'
                style={{ width: '100%' }}
                onChange={onChangePostCodeForUpdateAddress}
                defaultValue={formdata ? formdata.postal_code : null}
              />
            </Grid>
          </Grid>

          <Grid container style={{ paddingTop: '15px' }}>
            <Grid item md={12}>
              <TextField
                type='text'
                label={t('address')}
                className={classes.borderColorTextfield}
                variant='outlined'
                size='small'
                style={{ width: '100%' }}
                multiline
                onChange={onChangeAddressForUpdateAddress}
                defaultValue={formdata ? formdata.address : null}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopUpdateAddress} style={{ color: webThemeColor }}>
            {t('cancel1')}
          </Button>
          <Button
            variant='contained'
            onClick={handleClickChangeAddressUpdate}
            style={{ backgroundColor: webThemeColor, color: 'white' }}
          >
            {t('save')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default LeftCheckout
